.LogoSuite {
  padding-block-end: var(--brand-LogoSuite-logobar-rowGap);
}

.LogoSuite--default + .LogoSuite--default {
  padding-block-start: var(--brand-LogoSuite-logobar-rowGap);
}

/* Small monospace heading when standalone (no description) */
.LogoSuite:not(:has(.LogoSuite__description)) .LogoSuite__heading {
  font-family: var(--brand-fontStack-monospace);
  font-weight: var(--brand-text-weight-100);
  font-size: var(--brand-text-size-100);
  line-height: var(--brand-text-lineHeight-100);
  letter-spacing: var(--brand-text-letterSpacing-100);
  text-transform: uppercase;
  color: var(--brand-color-text-muted);
}

.LogoSuite__heading + .LogoSuite__description {
  padding-block-start: var(--base-size-16);
}

.LogoSuite--start {
  text-align: left;
}

.LogoSuite--center,
.LogoSuite--justify {
  text-align: center;
}

.LogoSuite--default:not(.LogoSuite + .LogoSuite) .LogoSuite__logobar {
  padding-block-start: var(--base-size-32);
}

.LogoSuite__logobar {
  display: flex;
  flex-wrap: wrap;
  row-gap: var(--brand-LogoSuite-logobar-rowGap);
  justify-content: center;
}

.LogoSuite__logobar--gap-default {
  --marquee-gap: var(--brand-LogoSuite-logobar-marquee-gap-default);
  column-gap: var(--brand-LogoSuite-logobar-columnGap-default);
}

.LogoSuite__logobar--gap-condensed {
  --marquee-gap: var(--brand-LogoSuite-logobar-marquee-gap-condensed);
  column-gap: var(--brand-LogoSuite-logobar-columnGap-condensed);
}

.LogoSuite:not(.LogoSuite + .LogoSuite)
  .LogoSuite__heading:not(.LogoSuite__heading--visually-hidden)
  + .LogoSuite__logobar,
.LogoSuite:not(.LogoSuite + .LogoSuite) .LogoSuite__description + .LogoSuite__logobar {
  padding-block-start: 0;
  margin-block-start: var(--base-size-44);
}

.LogoSuite__logobar--variant-muted svg,
.LogoSuite__logobar--variant-muted img,
.LogoSuite__logobar--variant-muted a,
.LogoSuite__logobar--variant-emphasis svg,
.LogoSuite__logobar--variant-emphasis img,
.LogoSuite__logobar--variant-emphasis a {
  width: auto;
  height: var(--base-size-32);
}

.LogoSuite__logobar img {
  display: block;
}

.LogoSuite__logobar--variant-muted svg,
.LogoSuite__logobar--variant-muted path {
  fill: var(--brand-LogoSuite-color-logo-muted);
}

.LogoSuite__logobar--variant-muted img {
  filter: var(--brand-LogoSuite-color-logo-filter-muted);
}

.LogoSuite__logobar--variant-emphasis svg,
.LogoSuite__logobar--variant-emphasis path {
  fill: var(--brand-LogoSuite-color-logo-emphasis);
}

.LogoSuite__logobar--variant-emphasis img {
  filter: var(--brand-LogoSuite-color-logo-filter-emphasis);
}

.LogoSuite--start .LogoSuite__logobar {
  justify-content: center;
}

@media screen and (min-width: 48rem) {
  .LogoSuite--justify .LogoSuite__logobar {
    justify-content: space-between;
  }
}

.LogoSuite__logobar a:focus-visible {
  outline: var(--brand-borderWidth-thick) solid var(--brand-color-focus);
  outline-offset: var(--base-size-2);
  border-radius: var(--base-size-4);
}

.LogoSuite--hasDivider {
  border-bottom: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
}

.LogoSuite__logobar--has-marquee {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--base-size-24);
  margin: auto;
  max-width: 100vw;
}

.LogoSuite__logobar-marqueeGroup {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: var(--marquee-gap);
  min-width: 100%;
  animation-name: LogobarScrollX;
  animation-duration: var(--brand-LogoSuite-logobar-marquee-default);
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
}

.LogoSuite__logobar-marqueeGroup--speed-default {
  animation-duration: var(--brand-LogoSuite-logobar-marquee-default);
}

.LogoSuite__logobar-marqueeGroup--speed-slow {
  animation-duration: var(--brand-LogoSuite-logobar-marquee-slow);
}

@keyframes LogobarScrollX {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - var(--marquee-gap)));
  }
}

.LogoSuite__logobar-marquee:hover .LogoSuite__logobar-marqueeGroup,
.LogoSuite__logobar-marquee:focus-within .LogoSuite__logobar-marqueeGroup {
  animation-play-state: paused;
}

.LogoSuite__logobar-marquee {
  display: flex;
  overflow-x: hidden;
  overflow-y: visible;
  padding-block: var(--base-size-4);
  user-select: none;
  gap: var(--marquee-gap);
  flex: 1;
  min-width: 0;
  -webkit-mask-image: linear-gradient(
    to right,
    hsl(0 0% 0% / 0),
    hsl(0 0% 0% / 1) 20%,
    hsl(0 0% 0% / 1) 80%,
    hsl(0 0% 0% / 0)
  );
  mask-image: linear-gradient(to right, hsl(0 0% 0% / 0), hsl(0 0% 0% / 1) 20%, hsl(0 0% 0% / 1) 80%, hsl(0 0% 0% / 0));
}

.LogoSuite__logobar--paused * {
  animation-play-state: paused !important;
}

.LogoSuite__logobar-marquee--focused .LogoSuite__logobar-marqueeGroup {
  animation-name: none;
}

.LogoSuite__logobar-playPauseButton {
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--base-size-32);
  height: var(--base-size-32);
  margin: 0;
  padding: 0;
  border: none;
  border-radius: var(--base-size-48);
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  background-color: var(--brand-LogoSuite-color-control-rest);
  transition: background-color var(--brand-animation-duration-faster);
}

.LogoSuite__logobar-playPauseButton:hover {
  background-color: var(--brand-LogoSuite-color-control-hover);
}

.LogoSuite__logobar-playPauseButton:focus-visible {
  outline: var(--base-size-4) solid var(--brand-color-focus);
  outline-offset: var(--base-size-2);
}

.LogoSuite__logobar-playPauseButton svg {
  width: var(--base-size-16);
  height: var(--base-size-16);
  fill: var(--brand-color-text-muted);
}

.LogoSuite__logobar-playPauseButton path {
  fill: var(--brand-color-text-muted);
}

/* Gridline expressive variant styles */
.LogoSuite--gridline-expressive {
  padding: 0;
}

.LogoSuite--gridline-expressive .LogoSuite__content {
  padding-inline: 0;
  gap: 0;
}

.LogoSuite--gridline-expressive .LogoSuite__textContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: var(--base-size-20);
}

.LogoSuite--gridline-expressive .LogoSuite__logobar {
  margin-block-start: auto;
}
.LogoSuite--gridline-expressive .LogoSuite__logobarContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: var(--base-size-32) var(--base-size-20) var(--base-size-32);
}

.LogoSuite--gridline-expressive .LogoSuite__logobar,
.LogoSuite--gridline-expressive .LogoSuite__logobar--has-marquee {
  max-width: none;
  width: 100%;
}

.LogoSuite--gridline-expressive .LogoSuite__heading + .LogoSuite__description {
  padding-block-start: var(--base-size-8);
}

.LogoSuite--gridline-expressive .LogoSuite__logobar {
  padding-block-start: 0;
}

@media screen and (min-width: 48rem) {
  .LogoSuite--gridline-expressive {
    padding-inline: 91px;
  }

  .LogoSuite--gridline-expressive .LogoSuite__logobarContainer {
    padding: var(--base-size-40);
  }
  .LogoSuite--gridline-expressive .LogoSuite__content {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
  .LogoSuite--gridline-expressive .LogoSuite__textContainer {
    border-inline-end: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }
}

@media screen and (min-width: 64rem) {
  .LogoSuite--gridline-expressive {
    padding-inline: 0;
  }

  .LogoSuite--gridline-expressive .LogoSuite__content {
    max-width: 1280px;
  }

  .LogoSuite--gridline-expressive .LogoSuite__textContainer {
    text-align: left;
    padding: var(--base-size-64);
  }

  .LogoSuite--gridline-expressive .LogoSuite__logobarContainer {
    padding: var(--base-size-64);
  }
}

@media screen and (min-width: 1281px) {
  .LogoSuite--gridline-expressive .LogoSuite__content {
    border-inline: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  }

  /* When the logobar is the only column visible (no adjacent text), this removes start border */
  .LogoSuite--gridline-expressive .LogoSuite__logobarContainer:first-child {
    border-inline-start: none;
  }
}

.LogoSuite__logobar--has-takeover {
  position: relative;
  overflow: visible;
}

/* Glass blur overlay effect */
.LogoSuite__logobar--has-takeover::before {
  content: '';
  position: absolute;
  inset: calc(-1 * var(--base-size-16)) 0;
  z-index: 1;
  pointer-events: none;
  opacity: 0;
  backdrop-filter: blur(var(--base-size-6));
  -webkit-backdrop-filter: blur(var(--base-size-6));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.LogoSuite__logobar--has-takeover:hover::before,
.LogoSuite__logobar--has-takeover:focus-within::before {
  opacity: 1;
}

.LogoSuite__logobar--has-takeover:hover svg,
.LogoSuite__logobar--has-takeover:focus-within svg,
.LogoSuite__logobar--has-takeover:hover img,
.LogoSuite__logobar--has-takeover:focus-within img {
  opacity: 0.7;
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.LogoSuite__logobar-takeoverButtonContainer {
  opacity: 0;
  visibility: hidden;
  z-index: 2;
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.LogoSuite__logobar--has-takeover:hover .LogoSuite__logobar-takeoverButtonContainer,
.LogoSuite__logobar--has-takeover:focus-within .LogoSuite__logobar-takeoverButtonContainer {
  opacity: 1;
  visibility: visible;
}
